// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2FyIZ","btnSubmit":"Footer_btnSubmit__mqY99","btnCancel":"Footer_btnCancel__udtLM"};